import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";

function useAccountService() {
  const apiClientHelper = useAPIClientHelper();

  const getAccounts = (filter: WintSuperkollAPIModelAccounting.AccountFilter) => {
    return apiClientHelper
      .apiClientInstance(AuthEnums.AuthType.Company)
      .AccountClient.Get(filter)
      .then((res) => res.data);
  };

  const getAccountBalance = (account: number) => {
    return apiClientHelper
      .apiClientInstance(AuthEnums.AuthType.Company)
      .AccountClient.GetAccountBalance(account)
      .then((res) => res.data);
  };

  const accountingCompletedUntil = () => {
    return apiClientHelper
      .apiClientInstance(AuthEnums.AuthType.Company)
      .AccountClient.GetAccountingDoneUntilMonth()
      .then((res) => {
        if (res.status === 204) {
          return undefined;
        }

        return res.data;
      });
  };

  const getRevenueAccounts = () => {
    return apiClientHelper
      .apiClientInstance(AuthEnums.AuthType.Company)
      .AccountClient.GetRevenueAccounts()
      .then((res) => res.data);
  };

  return {
    getAccounts,
    getAccountBalance,
    accountingCompletedUntil,
    getRevenueAccounts,
  };
}

export default useAccountService;
